import { makeLocations } from 'src/main/factories/pages'

export default makeLocations
